import { useEffect } from "react";

const ensureMetaTag = (name) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensurePropertyTag = (property) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureCanonical = () => {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  return tag;
};

const usePageMeta = (title, description, options = {}) => {
  const canonical = options.canonical || "https://mayr-technologies.com/";
  const schemaJson = options.schema ? JSON.stringify(options.schema) : null;

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (description) {
      const descriptionTag = ensureMetaTag("description");
      descriptionTag.setAttribute("content", description);
    }

    ensureCanonical().setAttribute("href", canonical);
    ensurePropertyTag("og:title").setAttribute("content", title || "Mayr Technologies");
    ensurePropertyTag("og:description").setAttribute("content", description || "");
    ensurePropertyTag("og:url").setAttribute("content", canonical);

    if (schemaJson) {
      let script = document.getElementById("mayr-page-schema");
      if (!script) {
        script = document.createElement("script");
        script.id = "mayr-page-schema";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = schemaJson;
    }

    return () => {
      const script = document.getElementById("mayr-page-schema");
      if (script) script.remove();
    };
  }, [title, description, canonical, schemaJson]);
};

export default usePageMeta;
